import React, { Component } from 'react';
import CampaignSave from './CampaignSave';
import CampaignList from './CampaignList';
import { connect } from 'react-redux';
import { showError } from 'actions/CommonActions';
import LOOKUP from 'constants/lookup';
import WithRouter from 'custom/withRouter';

class CampaignPage extends Component {
    constructor(props, context) {
        const campaignId = props.params.id;
        super(props, context);
        this.state = {
            status: campaignId ? "EDIT" : "LIST"
        };
    }

    redirectToAddPage() {
        this.props.navigate("/manage/campaign/add");
    }

    redirectToListPage() {
        this.props.navigate("/manage/campaign");
    }

    render() {
        const campaignId = this.props.params.id;
        const isSave = campaignId || this.props.location.pathname === "/manage/campaign/add";
        return (
            <React.Fragment>
                {isSave ?
                        (<CampaignSave
                            name="campaignSave"
                            params={this.props.params} />)
                        : (<CampaignList />)}
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showError: (message) => dispatch(showError(message))
    };
}



export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(CampaignPage));